/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies, ember/require-tagless-components */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { filterBy } from '@linc-technologies/linced-common/utils/arrays';

export default class SearchResultsGrid extends Component {
  people = null;
  staffUsers = null;
  PersonType = PersonType;
  EnrolmentStatus = EnrolmentStatus;

  @computed('people.@each.type')
  get learners() {
    return this.people.filter((person) => person.type === PersonType.LEARNER);
  }

  @computed('learners.@each.enrolmentStatus')
  get currentLearners() {
    return this.learners.filter((learner) => {
      let status = learner.get('enrolmentStatus');
      return (
        status === EnrolmentStatus.PENDING || status === EnrolmentStatus.CURRENT
      );
    });
  }

  @computed('learners.@each.enrolmentStatus')
  get formerLearners() {
    return filterBy(this.learners, 'enrolmentStatus', EnrolmentStatus.FORMER);
  }

  @computed('learners.@each.enrolmentStatus')
  get futureLearners() {
    return filterBy(
      this.learners,
      'enrolmentStatus',
      EnrolmentStatus.PRE_ENROLLED,
    );
  }

  @computed('people.@each.type')
  get staff() {
    let allStaff = this.people.filter(
      (person) => person.type === PersonType.STAFF,
    );
    let userIds = this.staffUsers
      .filter((user) => !user.disabled)
      .map((user) => user.id);
    return allStaff.filter((person) => {
      return isEmpty(person.userId) || userIds.includes(person.userId);
    });
  }

  @computed('people.@each.type')
  get caregivers() {
    return this.people.filter((person) => person.type === PersonType.CAREGIVER);
  }
}
